<template>
    <div>
        <SGPFormBotaoComponent color="primary" @click="abrirModal">
            <SGPIconComponent icon="mdi-file-export" color="second" />
            Exportar
        </SGPFormBotaoComponent>


        <SGPModalComponent v-if="abrirModalExportar" titulo="Exportar" @sgpModalFechar="fecharModalExportar">
            <div>
                <strong>Filtros aplicados serão utilizados para a exportação</strong>
            </div>
            <div class="mt-5">
                <div style="margin-bottom: 20px;">
                    <p>Selecione o formato de exportação: </p>
                    <input type="radio" name="exportar" id="exportar-csv" value="csv" v-model="formatoSelecionado" style="margin-right: 8px;">
                    <label for="exportar-csv" style="margin-right: 20px;">CSV</label>
                    <input type="radio" name="exportar" id="exportar-xlsx" value="xlsx" v-model="formatoSelecionado" style="margin-right: 8px;">
                    <label for="exportar-xlsx">XLSX</label>
                </div>
                <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;">
                    <SGPFormBotaoComponent color="secondary" @click="fecharModalExportar">
                        Cancelar
                    </SGPFormBotaoComponent>
                    <SGPFormBotaoComponent color="primary" @click="confirmarExportacao">
                        Exportar
                    </SGPFormBotaoComponent>
                </div>
            </div>
        </SGPModalComponent>
    </div>
</template>
<script>
export default {
    name: 'ModosWebBotaoExportarComponent',


    props: {
        campos: {
            type: [Array, Object],
            required: true
        },
    },

    data() {
        return {
            abrirModalExportar: false,
            formatoSelecionado: 'csv',
        }
    },

    methods: {
        abrirModal() {
            this.abrirModalExportar = true;
        },
        fecharModalExportar() {
            this.abrirModalExportar = false;
            this.formatoSelecionado = 'csv';
        },
        confirmarExportacao() {
            if (this.formatoSelecionado) {
                this.$emit('exportar', {
                    formato: this.formatoSelecionado,
                    filtro: this.campos
                });
                this.fecharModalExportar();
            }
        }
    }
}
</script>